import { createContext, ReactNode, useContext } from 'react';
import { getThrowingDefaultContextValue } from '@shared/helpers/react.helpers';
import { AspectRatio, ScalingStrategy } from './report.model';

type ReportContextValue = {
  header?: ReactNode;
  footer?: ReactNode;
  aspectRatio: AspectRatio;
  isFullscreen: boolean;
  isPrint: boolean;
  scalingStrategy: ScalingStrategy;
  exitFullscreen: (() => Promise<void>) | null;
};

export const ReportContext = createContext<ReportContextValue>(
  getThrowingDefaultContextValue('ReportPages must be children of <Report />'),
);

export const useReportContext = () => useContext(ReportContext);
